var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('navBar'),_c('router-view'),_c('foot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }